var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.imgList, function(item, index) {
    var m0 = _vm.$getImg(item)
    return {
      $orig: _vm.__get_orig(item),
      m0: m0
    }
  })

  var m1 = require("@/static/hotActivity/navigation.png")

  var m2 = require("@/static/hotActivity/icon.png")

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        m1: m1,
        m2: m2
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }